import { Table } from "@mantine/core";
import { NAVIGATE_ORDER } from "common/constants";
import { navigateTo } from "common/navigation";
import { formatDate, formatNZD } from "common/utils";
import { useNavigate } from "react-router-dom";
import { InvoiceSearchResult } from "types/model.types";

interface InvoiceCardProps {
  d: InvoiceSearchResult;
  onClose?: () => void;
}

const InvoiceCard: React.FC<InvoiceCardProps> = ({ d, onClose }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigateTo(`${NAVIGATE_ORDER}?id=${d.orderId}&s=${2}&e=1`);
    onClose && onClose?.();
  };

  return (
    <Table.Tr
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#f8f9fa")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
    >
      <Table.Td>{d.id}</Table.Td>
      <Table.Td>{d.orderId}</Table.Td>
      <Table.Td>{formatDate(d.createdOn)}</Table.Td>
      <Table.Td>{d.customer}</Table.Td>
      <Table.Td className="money">{formatNZD(d.amount)}</Table.Td>
      <Table.Td className="money">{formatNZD(d.gst)}</Table.Td>
    </Table.Tr>
  );
};

export default InvoiceCard;
